export const ADD_DEPARTMENT = 'ADD_DEPARTMENT';
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';